import { useTranslation } from 'react-i18next';
import { Modal } from 'rsuite';

import BasicButton from '../basicButton/basicButton';
import Btn from '../Btn/Btn';

import './confirmModal.css';

/**
 * Универсальное модальное окно подтверждения действия (удаление, отключение и т.п.).
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.open - Открыто ли модальное окно.
 * @param {() => void} props.onClose - Колбэк закрытия (отмена / крестик).
 * @param {() => void | Promise<void>} props.onConfirm - Колбэк подтверждения.
 * @param {string} props.titleKey - Ключ i18n для заголовка модалки.
 * @param {string} props.bodyKey - Ключ i18n для текста в теле (поддержка интерполяции).
 * @param {Object} [props.bodyInterpolation] - Объект для подстановки в bodyKey (напр. { contract_number: '123' }).
 * @param {string} props.confirmTextKey - Ключ i18n для кнопки подтверждения.
 * @param {string | null} [props.error] - Текст ошибки (показывается в теле модалки).
 * @param {boolean} [props.isLoading=false] - Идёт ли запрос (блокирует кнопки, loading на кнопке подтверждения).
 * @param {string} [props.confirmColor='red'] - Цвет кнопки подтверждения (red, green и т.д.).
 */
export default function ConfirmModal({
    open,
    onClose,
    onConfirm,
    titleKey,
    bodyKey,
    bodyInterpolation = {},
    confirmTextKey,
    error = null,
    isLoading = false,
    confirmColor = 'red',
}) {
    const { t } = useTranslation('basic');

    return (
        <Modal
            backdrop='static'
            role='alertdialog'
            open={open}
            onClose={onClose}
            size='xs'
        >
            <Modal.Header>
                <Modal.Title>{t(titleKey)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t(bodyKey, bodyInterpolation)}</p>
                {error && (
                    <p className='confirmModal_error'>{error}</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className='confirmModal_footer'>
                    <BasicButton
                        color={confirmColor}
                        onClick={onConfirm}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {t(confirmTextKey)}
                    </BasicButton>
                    <Btn
                        text={t('cancel')}
                        fluid
                        onClick={onClose}
                        disabled={isLoading}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
}
